export const Telegram = () => (
  <svg
    width=".8em"
    viewBox="0 0 149 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121 37.63L107.38 121.18C106.73 125.17 101.48 126.45 97.83 123.56C86.71 114.76 76.07 106.33 65.87 98.26C61.32 94.66 60.61 88.56 64.24 84.7C72.74 75.64 81.29 66.53 89.88 57.38C91.37 55.79 88.92 53.6 87.04 54.83C73.63 63.59 60.4701 72.18 47.5601 80.6C44.7901 82.41 41.19 82.66 38.11 81.28C30.9 78.06 23.8801 74.92 17.0501 71.86C13.3401 70.2 13.71 65.01 17.6 63.74L113.01 32.52C117.11 31.18 121.59 34 121 37.62V37.63Z"
      fill="currentColor"
    />
  </svg>
)
